import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"
import { withRouter } from "react-router";
import IndexBloc from "./Blocs/IndexBloc"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input,
    Modal, ModalBody, ModalFooter, ModalHeader,
    FormGroup, FormFeedback, Label
} from "reactstrap"

import TableActiveComponent from './Components/TablePrimaryComponent'
import TableSecondaryComponent from './Components/TableSecondaryComponent'
import TableDoneComponent from './Components/TableDoneComponent'

import moment from 'moment';

const IndexView = (props) => {

    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")
    const [period, setPeriod] = useState(null)
    const activeRef = useRef();
    const secondaryRef = useRef();
    const inactiveRef = useRef();

    const [nomorSurat, setNomorSurat] = useState("")
    const [nomorSuratValidation, setNomorSuratValidation] = useState(false)

    const [modal, setmodal] = useState(false)

    const queryParams = new URLSearchParams(props.location.search)
    useEffect(() => {
        indexBloc.periodDetailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        setPeriod(response);
                    }
                    break
                case apiResponse.ERROR:
    
                    break
                default:
                    break
            }
        })
    
        indexBloc.fetchPeriodDetail({ uuid: queryParams.get('uuid') })
    }, [])
    // get data unit
    
    const reloadSecondaryRef = () => secondaryRef.current.setTokenAPI()
    //const reloadInactiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card className="">
                            <CardBody>
                                <div className="float-end">
                                    {
                                        (accessRole('create')) ?
                                            <Link to={`?create_manual&period_uuid=${queryParams.get('uuid')}`}>
                                                <Button color="primary">Tambah Manual</Button>
                                            </Link>
                                            : null
                                    }

                                    {/* <Button color="primary" onClick={()=> reloadSecondaryRef()}>reload</Button> */}

                                </div>
                                <CardTitle>Daftar Pegawai Kenaikan Gaji Berkala</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Periode : {period != null ? moment().month((period.kgb_period_month - 1)).locale('id-id').format('MMMM') : '-'} {period != null ? period.kgb_period_year : '-'}
                                </CardSubtitle>
                                <hr />
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeTab === "1",
                                            })}
                                            onClick={() => {
                                                toggle("1")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                            <span className="d-none d-sm-block">Data Usulan</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeTab === "2",
                                            })}
                                            onClick={() => {
                                                toggle("2")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Data Diproses</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: activeTab === "3",
                                            })}
                                            onClick={() => {
                                                toggle("3")
                                            }}
                                        >
                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                            <span className="d-none d-sm-block">Data Selesai</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={activeTab} className="p-3 text-muted">
                                    <TabPane tabId="1">
                                        <TableActiveComponent ref={activeRef} handleProcessSuccess={reloadSecondaryRef} uuid={queryParams.get('uuid')} />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <TableSecondaryComponent ref={secondaryRef} uuid={queryParams.get('uuid')} period={(period?.kgb_period_full + '').substring(0, 4) + '-' + (period?.kgb_period_full + '').substring((period?.kgb_period_full + '').length - 2)+'-01'} handleInactiveSuccess={reloadInactiveRef} />
                                        {/* <TableSecondaryComponent ref={secondaryRef} uuid={queryParams.get('uuid')} period={'01-'+(period?.kgb_period_full+'').substring((period?.kgb_period_full+'').length-2)+'-'+(period?.kgb_period_full+'').substring(0, 4)}  handleInactiveSuccess={reloadInactiveRef}/> */}


                                    </TabPane>
                                    <TabPane tabId="3">
                                        <TableDoneComponent uuid={queryParams.get('uuid')} />
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default withRouter(IndexView);